<template>
  <textarea
    class="hl-text-area-input  text-gray-800 shadow-sm block w-full focus:outline-none focus:ring-offset-curious-blue-500 focus:border-curious-blue-500 sm:text-sm border-gray-300 rounded-md disabled:opacity-50"
    :value="modelValue"
    :placeholder="placeholder"
    name="description"
    @keyup="$emit('keyup', ($event.target as HTMLTextAreaElement).value)"
    @change="$emit('change', ($event.target as HTMLTextAreaElement).value)"
    @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
    @blur="$emit('blur', ($event.target as HTMLTextAreaElement).value)"
    @focus="$emit('focus', ($event.target as HTMLTextAreaElement).value)"
    @keyup.enter.exact="$emit('enter', ($event.target as HTMLTextAreaElement).value)"
    @keydown.enter.shift.exact="$emit('shift-enter', ($event.target as HTMLTextAreaElement).value)"
    :class="{'resize-none' : !expandable }"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  emits: ['update:modelValue', 'keyup', 'change', 'blur', 'focus', 'enter', 'shift-enter'],
  $_veeValidate: {
    value() {
      return this.modelValue
    },
  },
  props: {
    modelValue: String,
    placeholder: String,
    expandable: {
      type: Boolean,
      default: true
    }
  },
})
</script>

<style scoped></style>
